import { RdExpenditureYear } from './rd-expenditure-year.model';

export class IncreaseInRdCalculation {
  year: RdExpenditureYear;

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
